import { getVarValue } from '../../common/utils/Sparky'
import { FF_IAM_USE_ONEAPP_NAME, FF_USE_NEW_PA_LABEL } from '../../common/utils/FeatureFlags'

const useOneAppName = getVarValue(FF_IAM_USE_ONEAPP_NAME)
const useNewLabel = getVarValue(FF_USE_NEW_PA_LABEL)

const IAMAppName = (value: string, getAppName: Function) => {
  const appName = getAppName(value, value)

  if (useOneAppName && ['Prisma Access', 'Strata Access'].includes(appName)) {
    return useNewLabel ? `${appName} & NGFW Configuration` : `${appName} + NGFW`
  }

  return appName
}

export default IAMAppName
